<template>
  <div style="display: contents">
  <payment-method v-for="m in methods"
      :icon="`https://widget.donatepay.ru/images/pay/icons/${m.id}.svg`"
      :title="m.title"
      :id="m.id"
      @paymentClick="id => processPayment(id)"
  />
  </div>
</template>

<script>
import jwt from "@/plugins/jwt";
import PaymentMethod from "@/components/payment/PaymentMethod.vue";

export default {
  components: {PaymentMethod},
  props: {
    mdata: {
      type: Object
    },
  },
  name: "DonatePayPayment",
  computed: {
    methods() {
      if (!this.mdata || !this.mdata.methods) return []
      const json = JSON.parse(this.mdata.methods)
      if (!Array.isArray(json)) {
        return []
      }
      return json.map(method => {
        return {
          id: method.code,
          title: method.label,
          min: Number.parseInt(method.min),
          max: Number.parseInt(method.max)
        }
      })
    }
  },
  data() {
    return {
      rd : null,
      rules : [
          v => !!v || this.$t('errors.empty'),
      ],
      loading : false,
    }
  },
  methods: {
    processPayment(paymentId){
      const params = {
        callback: (amount) => this.send(paymentId, amount),
        min: this.methods.find(m => m.id === paymentId).min,
        max: this.methods.find(m => m.id === paymentId).max,
      }
      this.$emit('showAmountPopup', params)
    },
    send(paymentId, amount) {
      const uid = jwt.getUserId()
      location.href = `${this.mdata.handler}/${this.mdata.id}/${uid}/${amount}/${paymentId}`
    }
  },
}
</script>

<style scoped>
</style>